import { ref } from 'firebase/database';
import { Slot } from '@opanuj/shared/types';
import { useDatabase } from './useDatabase';
import { useListVals, useObjectVal } from 'react-firebase-hooks/database';
import { withDefaultList, withDefaultObject } from './defaults';

export const useSlotsList = () => {
	const database = useDatabase();
	const [slots, loading, error] = useListVals<Slot>(ref(database, 'slots'), { keyField: 'id' });
	return [withDefaultList(slots), loading, error] as const;
}

export const useSlots = () => {
	const database = useDatabase();
	const [slots, loading, error] = useObjectVal<{ [slotId: string]: Slot }>(ref(database, 'slots'), { keyField: 'id' });
	return [withDefaultObject(slots), loading, error] as const;
}